<template>
    <div
        id="section-header_content"
        class="section-header"
        :class="{ 'no-login': !$store.state.isLoggedIn }"
    >
        <nav id="section-header__nav-menu" class="section-header__nav">
            <div class="logo-container">
                <div class="burger">
                    <div class="line-1"></div>
                    <div class="line-2"></div>
                    <div class="line-3"></div>
                </div>
                <div class="logo">
                    <img
                        @click="routerPush('/')"
                        class="user-cart icon-header"
                        src="@/assets/images/header/OMillionaire_logo_Final.svg"
                    />
                </div>
            </div>
            <div
                class="section-header__menus"
                :class="{ 'no-login': !$store.state.isLoggedIn }"
            >
                <div
                    v-for="(item, index) in menus"
                    :key="index"
                    class="section-header__menus__menu t-transform-cap"
                    :class="{ hideDesktop: item.isDesktop === false }"
                    @click="handleClickRedirect(item)"
                >
                    {{ renderMutiLang(item.title) }}
                </div>
                <button
                    v-if="$store.state.isLoggedIn"
                    @click="onShowVoucherCode"
                    class="section-header__voucher section-voucher t-transform-cap">
                    {{ getTranslatedText("Use Voucher Code") }}
                </button>
            </div>
            <div class="nav-links">
                <div class="menu-header">
                    <img
                        @click="routerPush('/home')"
                        class="icon-header-menu"
                        src="@/assets/images/header/logo_new.png"
                    />
                    <img
                        class="icon-header-menu close-icon"
                        src="@/assets/images/header/close.png"
                    />
                </div>
                <div v-if="!$store.state.isLoggedIn" class="menu-menus">
                    <div class="menu-menus__title t-transform-cap">
                        {{
                            getTranslatedText(
                                "plant Trees, Become a Millionaire!"
                            )
                        }}
                    </div>
                    <div class="menu-menus__buttons">
                        <div class="menu-menus__buttons-box">
                            <div
                                @click="handleRegister"
                                class="menu-menus__buttons__register t-transform-cap"
                            >
                                {{ getTranslatedText("create account") }}
                            </div>
                            <div
                                @click="handleLogin"
                                class="menu-menus__buttons__login t-transform-cap"
                            >
                                {{ getTranslatedText("login") }}
                            </div>
                        </div>
                        <div class="social-divider">
                            <span>{{ getTranslatedText("or") }}</span>
                        </div>
                        <SocialSignUp
                            @onLogin="onLoginSocial"
                            :isLoadingButton="false"
                            :isShowIconCommon="true"
                        />
                    </div>
                </div>
                <div class="menu-menus__items">
                    <div
                        v-if="$store.state.isLoggedIn"
                        class="menu-menus__items__menu balance t-transform-cap"
                    >
                        <span class="menu-menus__items__menu__balance">
                            {{ getTranslatedText("balance") }}:
                            {{ formatPrice($store.state.balance) }}
                            {{ getTranslatedText($store.state.currency_code) }}
                        </span>
                        <button
                            class="btn-deposit"
                            @click="onClickRedirectMyWallet"
                        >
                            {{ getTranslatedText("deposit") }}
                        </button>
                        <button
                            v-if="$store.state.isLoggedIn"
                            @click="onShowVoucherCodeMobile"
                            class="section-header__voucher section-voucher t-transform-cap">
                            {{ getTranslatedText("Use Voucher Code") }}
                        </button>
                    </div>
                    <div
                        v-for="(item, key) in menus"
                        :key="key"
                        class="menu-menus__items__menu t-transform-cap"
                        :class="{
                            menuLanguage: item.slot === 'language',
                            menuAccount: item.slot === 'account',
                            menuLogout: item.slot === 'info-user',
                            hideMenuLogout:
                                item.slot === 'info-user' &&
                                !$store.state.isLoggedIn,
                            hideMenuAccount:
                                item.slot === 'account' &&
                                !$store.state.isLoggedIn,
                        }"
                        @click="
                            handleClickAccountItem(
                                item.path,
                                item.isPathDesk,
                                item.isRedirect,
                                'isNewTab' in item ? item.isNewTab : false
                            )
                        "
                    >
                        <div
                            v-if="
                                item.slot === 'info-user' &&
                                $store.state.isLoggedIn
                            "
                            class="menu-menus__items__menu__user-info"
                        >
                            <b-avatar size="23px">
                                <img
                                    v-if="$store.state.srcAvatar !== ''"
                                    class="user-cart icon-header"
                                    :src="$store.state.srcAvatar"
                                />
                                <img
                                    v-else
                                    class="user-cart icon-header"
                                    src="@/assets/images/header/account/avatar.png"
                                />
                            </b-avatar>

                            <div
                                class="menu-menus__items__menu__user-info__name"
                            >
                                {{ userName }}
                            </div>
                        </div>
                        {{
                            item.slot !== "account"
                                ? renderMutiLang(item.title)
                                : ""
                        }}
                        <div
                            v-if="
                                item.slot === 'info-user' &&
                                $store.state.isLoggedIn
                            "
                            @click="handleLogout"
                            class="menu-menus__items__menu__logout t-transform-cap"
                        >
                            {{ getTranslatedText("log out") }}
                        </div>
                        <div
                            v-if="item.slot === 'account'"
                            class="menu-menus__icon-dropdown__account"
                        >
                            {{ renderMutiLang(item.title) }}
                            <img
                                src="@/assets/images/header/dropdown-icon.png"
                            />
                        </div>
                        <div
                            v-if="
                                item.slot === 'account' &&
                                isShowMenusAccount &&
                                $store.state.isLoggedIn
                            "
                            class="menu-menus__items__menu__account"
                        >
                            <div
                                v-for="(account, i) in menusAccount"
                                :key="i"
                                v-show="account.isShow"
                                @click="
                                    handleClickAccountItem(
                                        account.url,
                                        null,
                                        account.isRedirect
                                    )
                                "
                                class="menu-menus__items__menu__account__item t-transform-cap"
                            >
                                <img
                                    :src="
                                        require(`@/assets/images/navigation/${account.icon}`)
                                    "
                                />
                                {{ getTranslatedText(account.title) }}
                            </div>
                        </div>
                        <div
                            v-if="item.slot === 'language'"
                            class="menu-menus__items__menu__language"
                        >
                            <div
                                @click="onChangeLanguage('in')"
                                :class="{
                                    activeBtn: isActiveLanguage === 'in',
                                }"
                                class="menu-menus__language__btn-left"
                            >
                                हिन्दी
                                <img
                                    class="flag-ar"
                                    src="@/assets/images/flags/Flag_of_India.svg"
                                />
                            </div>
                            <div
                                @click="onChangeLanguage('ar')"
                                :class="{
                                    activeBtn: isActiveLanguage === 'ar',
                                }"
                                class="menu-menus__language__btn-left"
                            >
                                عربي
                                <img
                                    class="flag-ar"
                                    src="@/assets/images/flags/Flag_of_Oman.svg"
                                />
                            </div>
                            <div
                                @click="onChangeLanguage('en')"
                                :class="{
                                    activeBtn: isActiveLanguage === 'en',
                                }"
                                class="menu-menus__language__btn-right"
                            >
                                English
                                <img
                                    class="flag-ar"
                                    src="@/assets/images/flags/Flag_of_the_United_Kingdom.svg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="connect-social">
                    <div class="connect-social__title t-transform-cap">
                        {{ getTranslatedText("connect with us on") }}
                    </div>
                    <div class="connect-social__items">
                        <div v-for="(item, key) in listSocial" :key="key">
                            <a :href="item.path" target="_blank">
                                <img
                                    class="connect-social__items__icon"
                                    :src="
                                        require(`@/assets/images/header/social/${item.srcIcon}`)
                                    "
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <img
                class="line-desktop"
                src="@/assets/images/header/line-desktop.png"
            />

            <div class="user-section">
                <a href="tel:+968 22 648383" class="icon-phone">
                    <img
                        class="icon-header"
                        src="@/assets/images/header/call.png"
                    />
                </a>
                <div
                    @click="handleNotify"
                    class="user-section__bell"
                    v-if="$store.state.isLoggedIn"
                >
                    <span
                        ><a>{{ $store.state.unreadNotify }}</a></span
                    >
                    <img
                        class="user-notify icon-header icon-bell"
                        src="@/assets/images/header/bell.png"
                    />
                </div>
                <div
                    v-if="!$store.state.is_app"
                    @click="handleMyCart"
                    class="user-section-cart t-transform-cap"
                    :class="{
                        'no-padding': $store.state.isLoggedIn,
                        'no-login': !$store.state.isLoggedIn,
                    }"
                >
                    <!-- <label class="user-section-cart__title-notify">
                        <span class="user-section-cart__text">3</span>
                    </label> -->
                    <div class="user-section-cart_quatity">
                        <span
                            ><a>{{ $store.state.amoutCart || 0 }}</a></span
                        >
                        <img
                            class="user-cart icon-header"
                            src="@/assets/images/header/shopping-cart.png"
                        />
                    </div>
                    <!-- <span class="text-cart" v-if="!$store.state.isLoggedIn">{{
                        getTranslatedText("my cart")
                    }}</span> -->
                </div>
                <div
                    @click="handleClickDropdown"
                    name="submit"
                    class="user-section__info"
                >
                    <b-avatar size="23px" v-if="$store.state.isLoggedIn">
                        <img
                            v-if="$store.state.srcAvatar !== ''"
                            class="user-cart icon-header"
                            :src="$store.state.srcAvatar" />
                        <img
                            v-else
                            class="user-cart icon-header"
                            src="@/assets/images/header/account/avatar.png"
                    /></b-avatar>
                    <div class="user-section__info__name">
                        <span v-if="$store.state.isLoggedIn"
                            >{{ userName }}
                        </span>
                        <img
                            v-if="
                                !$store.state.isLoggedIn &&
                                isActiveLanguage === 'in'
                            "
                            class="flag-ar"
                            src="@/assets/images/flags/Flag_of_India.svg"
                        />
                        <img
                            v-if="
                                !$store.state.isLoggedIn &&
                                isActiveLanguage === 'en'
                            "
                            class="flag-ar"
                            src="@/assets/images/flags/Flag_of_the_United_Kingdom.svg"
                        />
                        <img
                            v-if="
                                !$store.state.isLoggedIn &&
                                isActiveLanguage === 'ar'
                            "
                            class="flag-ar"
                            src="@/assets/images/flags/Flag_of_Oman.svg"
                        />
                    </div>
                    <div class="user-section__info__dropdown">
                        <b-dropdown
                            id="dropdown-right"
                            ref="dropdown"
                            right
                            variant="primary"
                            class="dropdown-custom"
                        >
                            <b-dropdown-form>
                                <template v-if="$store.state.isLoggedIn">
                                    <div
                                        class="user-section__info__dropdown__item balance t-transform-cap"
                                    >
                                        <span
                                            class="user-section__info__dropdown__item__balance"
                                        >
                                            {{ getTranslatedText("balance") }}:
                                            {{
                                                formatPrice(
                                                    $store.state.balance
                                                )
                                            }}
                                            {{
                                                getTranslatedText(
                                                    $store.state.currency_code
                                                )
                                            }}
                                        </span>
                                        <button
                                            type="button"
                                            class="btn-deposit"
                                            @click="onClickRedirectMyWallet"
                                        >
                                            {{ getTranslatedText("deposit") }}
                                        </button>
                                    </div>
                                    <div
                                        @click="handleOpenPath"
                                        class="user-section__info__dropdown__item t-transform-cap"
                                    >
                                        {{ getTranslatedText("my account") }}
                                    </div>
                                    <div
                                        class="user-section__info__dropdown__item t-transform-cap"
                                        @click="handleLogout"
                                    >
                                        {{ getTranslatedText("logout") }}
                                    </div>
                                </template>
                                <div
                                    class="user-section__info__dropdown__item__language"
                                    :class="{
                                        'no-border': !$store.state.isLoggedIn,
                                    }"
                                >
                                    <div
                                        class="user-section__info__dropdown__item__language__title t-transform-cap"
                                    >
                                        {{
                                            getTranslatedText("change language")
                                        }}
                                    </div>
                                    <div
                                        class="user-section__info__items__language"
                                    >
                                        <div
                                            @click="onChangeLanguage('in')"
                                            :class="{
                                                activeBtn:
                                                    isActiveLanguage === 'in',
                                            }"
                                            class="user-section__info__items__language__btn"
                                        >
                                            हिन्दी
                                            <img
                                                class="flag-ar"
                                                src="@/assets/images/flags/Flag_of_India.svg"
                                            />
                                        </div>
                                        <div
                                            @click="onChangeLanguage('ar')"
                                            :class="{
                                                activeBtn:
                                                    isActiveLanguage === 'ar',
                                            }"
                                            class="user-section__info__items__language__btn"
                                        >
                                            عربي
                                            <img
                                                class="flag-ar"
                                                src="@/assets/images/flags/Flag_of_Oman.svg"
                                            />
                                        </div>
                                        <div
                                            @click="onChangeLanguage('en')"
                                            :class="{
                                                activeBtn:
                                                    isActiveLanguage === 'en',
                                            }"
                                            class="user-section__info__items__language__btn"
                                        >
                                            English
                                            <img
                                                class="flag-ar"
                                                src="@/assets/images/flags/Flag_of_the_United_Kingdom.svg"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </b-dropdown-form>
                        </b-dropdown>
                    </div>
                </div>
            </div>

            <div
                v-if="!$store.state.isLoggedIn"
                class="section-header__buttons"
                :class="{ 'no-login': !$store.state.isLoggedIn }"
            >
                <SocialSignUp
                    @onLogin="onLoginSocial"
                    :isLoadingButton="false"
                    :isShowIconCommon="true"
                />
                <div
                    @click="handleLogin"
                    class="section-header__buttons__login t-transform-cap"
                >
                    {{ getTranslatedText("login") }}
                </div>
                <div
                    @click="handleRegister"
                    class="section-header__buttons__register t-transform-cap"
                >
                    {{ getTranslatedText("create account") }}
                </div>
            </div>
            <VoucherCode
                id="modalVoucherCode"
                @showToast="showToast"
                @onCancelModal="onHideVoucherCode"
            />
        </nav>
        <Toast id="header-toast" :title="toastData.message" :type="toastData.type" />
    </div>
</template>
<script>
import { listMenuNavigation } from "@/resources/listNavigation";
import {
    isArrayEmpty,
    isStrEmpty,
    redirectPathApp,
    redirectNewTab,
    renderLocaleNumber,
    renderLocalePrice,
} from "@/components/common/utils";
import { setUserInfo } from "@/services/axios";

import toolService from "@/services/tool.service";
import UserService from "@/services/user.service";
import authService from "@/services/auth.service";

import languageMixin from "@/mixins/language/language-mixin";
import RouterMixin from "@/mixins/router/router-mixin";

import Toast from "@/components/common/toast/Toast.vue";
import SocialSignUp from "@/components/common/socialLogin";
import VoucherCode from "@/components/common/voucherCode";
import EventBus from '@/components/common/EventBus';

export default {
    mixins: [languageMixin, RouterMixin],
    components: { SocialSignUp, Toast, VoucherCode},
    data() {
        return {
            toastData: {
                message: "",
                type: "success",
            },
            isActiveLanguage: "en",
            isShowMenusAccount: true,
            amountCart: "amount",
            userName: "",
            menus: [
                {
                    title: "language",
                    slot: "language",
                    path: "",
                    isDesktop: false,
                    isRedirect: false,
                },
                // {
                //     title: "home",
                //     path: "/home",
                //     isRedirect: true,
                // },
                {
                    title: "Buy now",
                    path: "/buy/green-certificates",
                    isRedirect: true,
                },
                {
                    title: "my account",
                    slot: "account",
                    isPathDesk: "/personal-detail",
                    isDesktop: false,
                    path: "my-account",
                    isRedirect: false,
                },
                { title: "draws", path: "/draws", isRedirect: false },
                {
                    title: "oasis park ",
                    path: "https://oasispark.om/",
                    isRedirect: false,
                    isNewTab: true,
                },
                // {
                //     title: "green Initiative",
                //     path: "/green",
                //     isRedirect: false,
                // },
                { title: `How to play`, path: "/how-to", isRedirect: false },
                {
                    title: "news",
                    path: "/news",
                    isRedirect: false,
                    isDesktop: false,
                },
                {
                    title: "about us",
                    path: "/about-us",
                    isRedirect: false,
                    isDesktop: false,
                },

                { title: "Contact us", path: "/contact-us", isRedirect: false },
                {
                    title: "",
                    slot: "info-user",
                    path: "",
                    isDesktop: false,
                    isRedirect: false,
                },
            ],
            menusAccount: listMenuNavigation,
            listSocial: [
                {
                    name: "youtube",
                    srcIcon: "youtube.png",
                    path: "https://www.youtube.com/channel/UCCZxGo-Fgh-Vd47jxUBjnww/featured",
                },
                {
                    name: "facebook",
                    srcIcon: "Facebook.png",
                    path: "https://www.facebook.com/OMillionaireom-110101778237267/",
                },
                {   name: "twitter", 
                    srcIcon: "twitter.png", 
                    path: "https://twitter.com/Omillionaire_me?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
                },
                {
                    name: "instagram",
                    srcIcon: "instagram.png",
                    path: "https://instagram.com/omillionaire.om?igshid=YmMyMTA2M2Y=",
                },
                // { name: "snapchat", srcIcon: "snapchat.png", path: "" },
                {
                    name: "tiktok",
                    srcIcon: "tiktok.png",
                    path: "https://www.tiktok.com/@omillionaire_me",
                },
            ],
        };
    },
    mounted() {
        this.navSlide();
        this.getUserData();
        // this.fetchMutilanguage();
        this.$store.dispatch("setUnreadNotify");
        this.$store.dispatch("setBalance");
    },
    created() {
        this.getTotalNotification();
    },
    methods: {
        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("header-toast");
        },

        async getTotalNotification() {
            this.$store.dispatch("setUnreadNotify");
        },

        handleOpenPath() {
            this.routerPush("/personal-detail");
            setTimeout(() => {
                this.$refs.dropdown.hide(true);
            }, 300);
        },

        getUserData() {
            if (this.$store.state.isLoggedIn) {
                UserService.getDataUser().then((res) => {
                    if (res) {
                        if (
                            isStrEmpty(res.dob) &&
                            isStrEmpty(res.gender) &&
                            isStrEmpty(res.nationality) &&
                            isStrEmpty(res.country_code)
                        ) {
                            this.$store.state.isUpdateProfile = true;
                        }
                        let locale = res?.locale_code || "en";
                        let userInfo = {
                            calling_code: res.phone_number,
                            email: res.email,
                            id: res.id,
                            name: `${res.first_name} ${res.last_name}`,
                            phone: res.phone_number,
                            address: res.address,
                            state: res.state,
                            city: res.city,
                            zipcode: res.zipcode,
                            country_code: res.country_code,
                        };
                        setUserInfo(userInfo);
                        this.userName = res.first_name;
                        localStorage.setItem("locale", locale);
                        this.fetchMutilanguage();
                        if (res.avatar) {
                            this.$store.dispatch(
                                "onChangeSrcAvatar",
                                res.avatar
                            );
                        }
                    } else {
                        this.userName = this.getTranslatedText("language");
                    }
                });
            } else {
                this.fetchMutilanguage();
            }
        },

        handleClickDropdown() {
            this.$refs.dropdown.show(true);
        },

        async fetchMutilanguage() {
            try {
                // need better way for config these language
                let supportLocale = ["en", "ar", "in"];
                await supportLocale.forEach(async (lang) => {
                    const data = await toolService.getMutiLanguage(lang);
                    localStorage.setItem(
                        "muti_language_" + lang,
                        JSON.stringify(data)
                    );
                });

                let locale = localStorage.getItem("locale")
                    ? localStorage.getItem("locale")
                    : "en";
                // const data = await toolService.getMutiLanguage(locale);
                // localStorage.setItem("muti_language", JSON.stringify(data));
                localStorage.setItem("locale", locale);
                this.isActiveLanguage = locale;
                const nav = document.querySelector(".nav-links");
                if (locale === "ar") {
                    document.body.setAttribute("dir", "rtl");
                    nav.classList.add("rtl");
                } else {
                    document.body.removeAttribute("dir");
                    nav.classList.remove("rtl");
                }
            } catch (error) {
                console.log(error);
            }
        },

        handleClickAccountItem(path, isPathDesk, isRedirect, isNewTab=false) {
            if (
                !isStrEmpty(path) ||
                (!isStrEmpty(isPathDesk) && window.screen.width > 767)
            ) {
                if (path === "my-account") {
                    this.isShowMenusAccount = !this.isShowMenusAccount;
                } else {
                    if (isNewTab) {
                        redirectNewTab(path);
                    } else if (this.$store.state.is_app && isRedirect) {
                        redirectPathApp(path);
                    } else {
                        this.handleCloseMenu();
                        this.routerPush(path);
                    }
                }
            }
        },
        handleLogout() {
            this.$store.dispatch("handleLogout");
            this.handleCloseMenu();
            this.routerPush("/login");
            setTimeout(() => {
                this.$refs.dropdown.hide(true);
            }, 300);
        },
        handleCloseMenu() {
            const nav = document.querySelector(".nav-links");
            const close = document.querySelector(".close-icon");
            close.classList.remove("close-icon-active");
            nav.classList.remove("nav-active");
        },
        handleRegister() {
            this.handleCloseMenu();
            this.routerPush({ path: "/register" });
        },
        handleLogin() {
            this.handleCloseMenu();
            window.location.href = "/login";
        },
        handleMyCart() {
            if(this.$store.state.amoutCart > 0) {
                if (this.$router.history.current.path !== "/checkout") {
                    this.routerPush("/checkout");
                }
            } else {
                this.routerPush("/tickets");
            }
        },
        handleNotify() {
            this.routerPush("/notifications");
        },
        navSlide() {
            const burger = document.querySelector(".burger");
            const nav = document.querySelector(".nav-links");
            const close = document.querySelector(".close-icon");

            burger.addEventListener(
                "click",
                () => {
                    nav.classList.add("nav-active");
                    close.classList.add("close-icon-active");
                },
                true
            );

            close.addEventListener(
                "click",
                () => {
                    close.classList.remove("close-icon-active");
                    nav.classList.remove("nav-active");
                },
                true
            );
        },

        onShowVoucherCode() {
            this.$bvModal.show("modalVoucherCode");
        },

        onHideVoucherCode() {
            EventBus.$emit('onHideVoucherCode');
            this.$bvModal.hide("modalVoucherCode");
        },

        onShowVoucherCodeMobile() {
            window.location.href = "/wallet?step=5";
        },

        async onChangeLanguage(locale) {
            if (this.$store.state.isLoggedIn) {
                try {
                    const resp = await authService.updateLocale(locale);
                    if (resp.status === 200) {
                        localStorage.setItem("locale", locale);
                        //this.isActiveLanguage = locale === "en" ? false : true;
                        this.isActiveLanguage = locale;
                        this.$router.replace({ query: null });
                        window.location.reload(true);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                localStorage.setItem("locale", locale);
                //this.isActiveLanguage = locale === "en" ? false : true;
                this.isActiveLanguage = locale;
                this.$router.replace({ query: null });
                window.location.reload(true);
            }
        },

        renderMutiLang(title) {
            return this.getTranslatedText(title);
        },

        renderNumberLocale(number) {
            return renderLocaleNumber(parseInt(number));
        },

        formatPrice(price) {
            price = price.replaceAll(",", "");
            return renderLocalePrice(parseFloat(price));
        },

        handleClickRedirect(item) {
            if (item.isNewTab) {
                redirectNewTab(item.path);
            } else if (this.$store.state.is_app && item.isRedirect) {
                redirectPathApp(item.path);
            } else {
                this.routerPush(item.path);
            }
        },

        onClickRedirectMyWallet() {
            window.location.href = "/wallet?step=4";
        },

        async onFinishLogin() {
            let listGame = !isStrEmpty(localStorage.getItem("list_games"))
                ? JSON.parse(localStorage.getItem("list_games"))
                : [];
            let totalCart = !isStrEmpty(localStorage.getItem("total_items"))
                ? parseInt(localStorage.getItem("total_items"))
                : 0;

            if (isArrayEmpty(listGame)) {
                await this.$router.push("/");
                return false;
            }

            try {
                const resp = await authService.getListCart();
                if (resp.status === 200) {
                    localStorage.setItem("isLogin", true);

                    let list_block_tmp =
                        totalCart > 0
                            ? JSON.parse(localStorage.getItem("list_block_tmp"))
                            : [];
                    let list_block_api =
                        parseInt(resp.data?.amount) > 0
                            ? JSON.parse(resp.data.cart_data)
                            : [];

                    if (!isArrayEmpty(list_block_tmp)) {
                        list_block_tmp = list_block_api.concat(list_block_tmp);
                        list_block_tmp = [...new Set(list_block_tmp)];

                        let amount = 0;

                        list_block_tmp.map((x) => {
                            amount += x.date.length;
                        });

                        let param = {
                            cart_data: list_block_tmp,
                            items: list_block_tmp.length,
                            amount,
                        };

                        const respSaveCart = await authService.saveListCart(
                            param
                        );

                        if (respSaveCart.status === 200) {
                            this.$store.dispatch(
                                "onChangeAnountCart",
                                parseInt(param.amount)
                            );
                            localStorage.setItem(
                                "list_block_tmp",
                                JSON.stringify(list_block_tmp)
                            );
                            localStorage.setItem(
                                "list_block",
                                JSON.stringify(list_block_tmp)
                            );
                            localStorage.setItem("total_items", param.amount);
                            window.location.href = "/checkout";
                        }
                    } else {
                        let amount = resp?.data?.amount
                            ? parseInt(resp.data.amount)
                            : 0;

                        localStorage.setItem(
                            "list_block_tmp",
                            JSON.stringify(list_block_api)
                        );
                        localStorage.setItem(
                            "list_block",
                            JSON.stringify(list_block_api)
                        );
                        localStorage.setItem("total_items", amount);

                        amount !== 0
                            ? (window.location.href = "/checkout")
                            : await this.$router.push("/");
                    }
                } else {
                    await this.$router.push("/");
                }
            } catch (error) {
                console.log(error);
            }
        },

        onLoginSocial(paramLoginSocial) {
            authService
                .loginByGoogle(paramLoginSocial.idToken, paramLoginSocial.type)
                .then((res) => {
                    if (res.status === 200) {
                        this.onFinishLogin();
                    } else {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                });
        },
    },
};
</script>
<style scoped lang="scss" src="@/assets/scss/mobile/_header.scss" />
